import { render } from "./TasklyView.vue?vue&type=template&id=aaca4980&scoped=true"
import script from "./TasklyView.vue?vue&type=script&lang=js"
export * from "./TasklyView.vue?vue&type=script&lang=js"

import "./TasklyView.vue?vue&type=style&index=0&id=aaca4980&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaca4980"]])

export default __exports__